import { createRoot } from 'react-dom/client';
import App from './components/container/App';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { store } from '@/redux/stores';

import './css/main.scss';
import 'thrive-components/dist/assets/thrive-components.css';
import 'thrive-forms/dist/thrive-forms.css';

const root = createRoot(document?.getElementById?.('react-loader') as HTMLElement)

root.render(
  <Provider store={store}>
      <App />
  </Provider>,
)  

serviceWorker.unregister()